import { getAuth } from 'firebase/auth';

const getHeaders = async () => {
  const auth = getAuth();
  const token = await auth.currentUser?.getIdToken();
  return {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {})
  };
};

export interface WidgetSettings {
  greeting: string;
  position: 'left' | 'right';
  color: string;
  text: string;
}

export const fetchWidgetSettings = async (): Promise<WidgetSettings> => {
  const headers = await getHeaders();
  const res = await fetch('/api/whatsapp/widget', { headers });
  if (!res.ok) throw new Error('Failed to fetch widget settings');
  return res.json();
};

export const saveWidgetSettings = async (settings: WidgetSettings): Promise<void> => {
  const headers = await getHeaders();
  const res = await fetch('/api/whatsapp/widget', {
    method: 'POST',
    headers,
    body: JSON.stringify(settings)
  });
  if (!res.ok) throw new Error('Failed to save widget settings');
};
